module.exports = __webpack_public_path__ + "48badacfa970821032ebea86fb823213.svg";